import React, { useLayoutEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import TestOurTech_thankyou from "./Components/TestOurTech_thankyou";
import RegisterForm from "./Components/RegisterForm";
import NotFound from "./Components/NotFound";
import RegisterService from "./services/register.service";
import { Helmet } from "react-helmet";

function App() {
  // checking of redeemption and register
  const [permissions, setPermissions] = useState(null);
  const [permissionsLoading, setPermissionsLoading] = useState(true);

  const LoadingBox = () => {
    return (
      <>
        <div className={`loader in bg-white`}>
          <div className="spinner-border main-spin"></div>
        </div>
      </>
    );
  };

  useLayoutEffect(() => {
    const getSiteDetailsPer = async () => {
      try {
        setPermissionsLoading(true);
        const response = await RegisterService.getSitePermissions();

        setPermissions(response?.data?.response || null);
        setPermissionsLoading(false);
      } catch (error) {
        setPermissions(null);
        setPermissionsLoading(false);
      }
    };
    getSiteDetailsPer();
  }, []);
  // checking of redeemption and register end
  if (process.env.REACT_APP_STAGE === "PROD")
    console.log = function no_console() {};
  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          component={
            permissionsLoading
              ? LoadingBox
              : permissions?.register === "yes"
              ? RegisterForm
              : NotFound
          }
        />
        <Route
          exact
          path="/TestOurTech_thankyou"
          component={
            permissionsLoading
              ? LoadingBox
              : permissions?.register === "yes"
              ? TestOurTech_thankyou
              : NotFound
          }
        />

        <Route exact path="*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
